/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Injectable} from '@angular/core';
import {AngularModalService} from '../common/modal/angular-modal.service';
import {TargetingEditorModalComponent} from './targeting-editor-modal.component';
import {TargetingEditorOptions, TargetingEditorResult} from './targeting-editor-state';

@Injectable({providedIn: 'root'})
export class TargetingEditorModalService {
  constructor(private readonly angularModalService: AngularModalService) {
  }

  /**
   * Opens the Angular targeting editor.
   * Resolves with `{wc, overrides, reset}` on save, or `null` if dismissed.
   */
  async open(options: TargetingEditorOptions): Promise<TargetingEditorResult | null> {
    const modalRef = await this.angularModalService.showAfterTick(TargetingEditorModalComponent, {
      animated: true,
      class: 'modal-xl adnDialog adnFullScreenDialog',
      initialState: {...options}
    });

    return new Promise((resolve) => {
      const content = modalRef.content as TargetingEditorModalComponent;
      let settled = false;

      content.onSaved.subscribe((result) => {
        settled = true;
        resolve(result);
      });

      modalRef.onHidden.subscribe(() => {
        if (!settled) {
          resolve(null);
        }
      });
    });
  }
}
